import { useQuery } from "@apollo/client";
import { SpogCompany } from "../../../../../legacy/types/SpogCompany";
import {
  CompanyFilter,
  CompanyMatchFilter,
} from "../../../../../legacy/types/companyFilter";
import { COMPANY_SEARCH_CLIENT } from "../../../../../utils/consts";
import { SortDirection } from "../../../../../legacy/types/misc";
import { buildCompanyListQuery } from "../../../../../apis/companySearch/companyList";
import { useMemo, useState } from "react";
export interface Props {
  filters: CompanyFilter | undefined;
  competitorPresence: number[];
  companyMatchFile: CompanyMatchFilter | null | undefined;
  page: number;
  rowsPerPage: number;
  sortField: string;
  sortDirection: SortDirection;
  localizeInstalls?: boolean;
}

export const useGetCompanyList = ({
  filters,
  competitorPresence,
  companyMatchFile,
  page,
  rowsPerPage,
  sortField,
  sortDirection,
  localizeInstalls = true,
}: Props) => {
  const { data, loading } = useQuery<{
    opportunity_generator_search: { data: SpogCompany[]; count: number };
  }>(
    buildCompanyListQuery({
      hasCompetitorPresence: competitorPresence.length > 0,
      hasMatchFile: !!companyMatchFile,
    }),
    {
      variables: {
        filters,
        page,
        per: rowsPerPage,
        sort: {
          field: sortField,
          direction: sortDirection.toUpperCase(),
        },
        competitorPresence,
        companyMatchFile,
        localizeInstalls,
      },
      context: {
        clientName: COMPANY_SEARCH_CLIENT,
      },
      skip: !filters,
    }
  );

  const resultsCount = data?.opportunity_generator_search?.count;
  const [lastResultsCount, setLastResultsCount] = useState<number | undefined>(
    0
  );
  // Preserve resultsCount during loading to maintain pagination
  const currentResultsCount = useMemo(() => {
    if (resultsCount !== undefined) {
      setLastResultsCount(resultsCount);
      return resultsCount;
    }
    return loading ? lastResultsCount : undefined;
  }, [resultsCount, loading, lastResultsCount]);

  return {
    data: data?.opportunity_generator_search.data || [],
    loading,
    count: currentResultsCount,
  };
};
